const css = `.alert {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  padding: 8px;
  border: 1px solid;
}
.alert.small-text {
  font-size: var(--font-size-xs);
}
.alert .alert-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.alert .alert-close-button {
  margin-left: auto;
  margin-bottom: auto;
  width: 24px;
  height: 24px;
}
.alert.info {
  border-color: var(--info);
  background-color: var(--info-subtle);
  color: var(--info);
}
.alert.info .alert-icon {
  color: var(--info);
}
.alert.warning {
  border-color: var(--warning);
  background-color: var(--warning-subtle);
  color: var(--warning);
}
.alert.warning .alert-icon {
  color: var(--warning);
}
.alert.error {
  border-color: var(--danger);
  background-color: var(--danger-subtle);
  color: var(--danger);
}
.alert.error .alert-icon {
  color: var(--danger);
}
.alert.secondary {
  border-color: var(--border-strong);
  background-color: var(--surface-sunken);
}
.alert.secondary .alert-icon {
  color: var(--text-muted);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvQWxlcnQiLCJzb3VyY2VzIjpbIkFsZXJ0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7QUFJSjtFQUNFO0VBQ0E7RUFDQTs7QUFDQTtFQUNFOztBQUlKO0VBQ0U7RUFDQTtFQUNBOztBQUNBO0VBQ0U7O0FBSUo7RUFDRTtFQUNBOztBQUNBO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIuYWxlcnQge1xuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZ2FwOiA4cHg7XG4gIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgcGFkZGluZzogOHB4O1xuICBib3JkZXI6IDFweCBzb2xpZDtcblxuICAmLnNtYWxsLXRleHQge1xuICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLXhzKTtcbiAgfVxuXG4gIC5hbGVydC1jb250ZW50IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgZ2FwOiA0cHg7XG4gIH1cblxuICAuYWxlcnQtY2xvc2UtYnV0dG9uIHtcbiAgICBtYXJnaW4tbGVmdDogYXV0bztcbiAgICBtYXJnaW4tYm90dG9tOiBhdXRvO1xuICAgIHdpZHRoOiAyNHB4O1xuICAgIGhlaWdodDogMjRweDtcbiAgfVxuXG4gICYuaW5mbyB7XG4gICAgYm9yZGVyLWNvbG9yOiB2YXIoLS1pbmZvKTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1pbmZvLXN1YnRsZSk7XG4gICAgY29sb3I6IHZhcigtLWluZm8pO1xuICAgIC5hbGVydC1pY29uIHtcbiAgICAgIGNvbG9yOiB2YXIoLS1pbmZvKTtcbiAgICB9XG4gIH1cblxuICAmLndhcm5pbmcge1xuICAgIGJvcmRlci1jb2xvcjogdmFyKC0td2FybmluZyk7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0td2FybmluZy1zdWJ0bGUpO1xuICAgIGNvbG9yOiB2YXIoLS13YXJuaW5nKTtcbiAgICAuYWxlcnQtaWNvbiB7XG4gICAgICBjb2xvcjogdmFyKC0td2FybmluZyk7XG4gICAgfVxuICB9XG5cbiAgJi5lcnJvciB7XG4gICAgYm9yZGVyLWNvbG9yOiB2YXIoLS1kYW5nZXIpO1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWRhbmdlci1zdWJ0bGUpO1xuICAgIGNvbG9yOiB2YXIoLS1kYW5nZXIpO1xuICAgIC5hbGVydC1pY29uIHtcbiAgICAgIGNvbG9yOiB2YXIoLS1kYW5nZXIpO1xuICAgIH1cbiAgfVxuXG4gICYuc2Vjb25kYXJ5IHtcbiAgICBib3JkZXItY29sb3I6IHZhcigtLWJvcmRlci1zdHJvbmcpO1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLXN1cmZhY2Utc3Vua2VuKTtcbiAgICAuYWxlcnQtaWNvbiB7XG4gICAgICBjb2xvcjogdmFyKC0tdGV4dC1tdXRlZCk7XG4gICAgfVxuICB9XG59XG4iXX0= */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
